export default "__VITE_ASSET__CP4_F_sJ__"